import type { SelectedAssignmentTarget } from './assignedLabelsTypes';

export const getTargetKey = (target: SelectedAssignmentTarget): string =>
  target.type === 'device'
    ? `device:${target.sn}`
    : `intL2:${target.sn}\0${target.interfaceName}`;

export const dedupeTargets = (
  targets: SelectedAssignmentTarget[],
): SelectedAssignmentTarget[] => {
  const seen = new Set<string>();
  return targets.filter((target) => {
    const key = getTargetKey(target);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

export const formatTargetOptionLabel = (
  sn: string,
  hostname: string | null,
): string => {
  const hostPart = hostname?.trim();
  return hostPart ? `${sn} (${hostPart})` : sn;
};

export const formatTargetChipLabel = (
  target: SelectedAssignmentTarget,
): string => {
  if (target.type === 'device') {
    return formatTargetOptionLabel(target.sn, target.hostname);
  }

  const deviceLabel = formatTargetOptionLabel(target.sn, target.hostname);
  return `${deviceLabel} - ${target.interfaceName}`;
};
